<div
    *ngIf="testInfo"
    class="container"
>
    <app-page-title [title]="'Request Test Re-evaluation'"></app-page-title>
    <br />
    <div class="panel">
        <p>
            You can apply for a re-evaluation of some or all components of your {{testInfo.testTypeName}} Test within six months of the test date. You must pay a re-evaluation fee at the time of your application that depends on which components of the test you would like re-evaluated. If the {{testInfo.testTypeName}} level changes for any component that has been re-evaluated, the re-evaluation fee for this component will be refunded. Please note that there is a limit of one re-evaluation for any particular component of the test. Re-evaluation requests are final sale, and cannot be cancelled once the request has been submitted.
        </p>
        <p *ngIf="brandId === BrandEnum.CELPIP">
            Test takers who apply for a re-evaluation of their test results will be notified of the results of the re-evaluation
            in approximately one to two weeks of submission of their application and payment of the re-evaluation fee.
        </p>
        <p *ngIf="brandId === BrandEnum.CAEL">
            Test takers who apply for a re-evaluation of their test results will be notified of the results of the re-evaluation
            within three to four weeks of submission of their application and payment of the re-evaluation fee.
        </p>
    </div>

    <app-page-title [title]="'Test Information'"></app-page-title>
    <div class="row">
        <div class="col-md-6">
            <p><strong>Registration Number:</strong> {{testInfo.regId}}</p>
            <p *ngIf="!testInfo.isWebDelivery"><strong>Test Centre: </strong> {{testInfo.testCentreName}}</p>
            <p *ngIf="!testInfo.isWebDelivery"><strong>Test Centre Location: </strong> {{testInfo.testCentreLocation}}</p>
            <p *ngIf="testInfo.isWebDelivery"><strong>Web Delivered Test</strong></p>
        </div>
        <div class="col-md-6">
            <p><strong>Test Date:</strong> {{testInfo.testDateTime | date}}</p>
            <p><strong>Test Type: </strong>{{testInfo.testTypeName}}</p>
        </div>
    </div>

    <app-page-title [title]="testInfo.testTypeName+' Component(s)'"></app-page-title>
    <div class="row">
        <form
            name="order-test-reevaluation-form"
            [formGroup]="reEvaluationProductsForm"
        >
            <div class="col-md-6 mw-100">
                <div
                    class="form-group mb-2"
                    *ngIf="components && components.length > 0"
                >
                    <label style="margin-bottom:15px;"><strong>Select Test Components to Re-evaluate:</strong></label>
                    <div
                        *ngFor="let component of components"
                        class="component"
                    >
                        <label class="test-components-label">
                            <input
                                type="checkbox"
                                (change)="onSelect($event)"
                                [value]="component.listPrice"
                                id={{component.id}}
                                name="component"
                                [disabled]="brandId === BrandEnum.CELPIP && component.id!=allFourCELPIPComponentsSelectedId && allFourComponentsSelected"
                            />
                            {{component.name}}
                        </label>
                        <label class="ml-1">{{component.listPrice | currency : component.currencyCode : component.currencyCode + " "}} </label>
                    </div>
                </div>
                <div
                    *ngIf="!components || components.length == 0"
                    class="my-3"
                >
                    <label style="margin-bottom:15px;">No available components for re-evaluation.</label>
                </div>

                <div
                    *ngIf="brandId === BrandEnum.CELPIP && testInfo.testTypeId === TestTypeEnum.CELPIP_G"
                    class="my-3"
                >
                    Please note that requesting a re-evaluation of the <strong>Listening and Reading components</strong> is unlikely to result in a change in your scores as they are computer rated.
                </div>

                <div
                    *ngIf="brandId === BrandEnum.CELPIP && testInfo.testTypeId === TestTypeEnum.CELPIP_LS"
                    class="my-3"
                >
                    Please note that requesting a re-evaluation of the <strong>Listening component</strong> is unlikely to result in a change in your score as that particular component is computer rated.
                </div>
            </div>
            <div
                *ngIf="components && components.length > 0"
                class="m-4"
            >
                <label class="total">
                    Total Amount:
                </label>
                <p>
                    {{ totalAmount | currency : currencyCode : currencyCode + " "}}
                </p>
            </div>
        </form>
    </div>

    <div class="row">
        <div class="col-md-12">
            <a
                [routerLink]="['/my-account']"
                class="btn btn-primary m-1"
            >Back</a>
            <button
                type="button"
                class="btn btn-primary m-1"
                (click)="addReEvaluationsToCart()"
                [disabled]="!productIds.length > 0"
                name="confirmationYesBtn"
            >
                <i class="fa fa-shopping-cart"></i> Add to cart
            </button>
        </div>
    </div>

    <div
        *ngIf="orderDate"
        class="my-3"
    >
        <app-page-title [title]="'e-evaluation Order Status'"></app-page-title>
        <div class="row">
            <div>
                <div class="col-md-6 mw-100">
                    Re-evaluation ordered on <strong> {{orderDate | date}}</strong>
                </div>
            </div>
        </div>
    </div>

</div>

<app-modal
    #errorModal
    title="Error"
    body="{{modalBody}}"
    (clickPositive)="redirectToMyAccount()"
>
</app-modal>
